import {NgModule} from '@angular/core';
import {FFAccordionContentComponent} from './components/ff-accordion/ff-accordion-content.component';
import {FFAccordionHeaderComponent} from './components/ff-accordion/ff-accordion-header.component';
import {FFAccordionComponent} from './components/ff-accordion/ff-accordion.component';
import {InputDebounceDirective} from './directives/input-debounce.directive';
import {JsonSchemaFormComponent} from './components/json-schema-form/json-schema-form.component';
import {IBaseCRUModalContentComponent} from './components/ibase-cru-modal-content/ibase-cru-modal-content.component';
import {IBaseCRUDContentComponent} from './components/ibase-crud-content/ibase-crud-content.component';
import {JsonSchemaFormModalComponent} from './modals/json-schema-form-modal/json-schema-form-modal.component';
import {InputRequirementIndicatorDirective} from './directives/input-requirement-indicator.directive';
import {PDatePickerFixDirective} from './directives/p-datepicker-fix.directive';

const elements = [
    IBaseCRUModalContentComponent,
    IBaseCRUDContentComponent,
    JsonSchemaFormComponent,
    JsonSchemaFormModalComponent,
    FFAccordionComponent,
    FFAccordionHeaderComponent,
    FFAccordionContentComponent,

    // Directives
    InputDebounceDirective,
    InputRequirementIndicatorDirective,
    PDatePickerFixDirective
];

@NgModule({
    imports: [...elements],
    exports: [...elements],
    providers: []
})
export class SdkImportsModule {}
